import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { AppLayoutComponent } from './presentations/layout/app.layout.component';
import { NotfoundComponent } from './presentations/components/notfound/notfound.component';
import { AdminGuard } from '@smatchy/ui-auth';
import { LoginComponent } from './presentations/pages/auth/login/login.component';
import { EventsComponent } from './presentations/pages/events/events.component';
import { UsersComponent } from './presentations/pages/users/users.component';
import { UserProfileComponent } from './presentations/pages/user-profile/user-profile.component';
import { PastEventsComponent } from './presentations/pages/past-events/past-events.component';
import { UserComponent } from './presentations/pages/user/user.component';
import { UserActivityComponent } from './presentations/pages/user-activity/user-activity.component';
import { EventRevenueComponent } from './presentations/pages/event-revenue/event-revenue.component';
import { PayoutRequestComponent } from './presentations/pages/payout-request/payout-request.component';
import { BalancesComponent } from './presentations/pages/balances/balances.component';
import { ReportComponent } from './presentations/pages/report/report.component'; 
import { GroupsManagementComponent } from './presentations/pages/groups-management/groups-management.component';
import { ActivitiesManagementComponent } from './presentations/pages/activities-management/activities-management.component';
import { UsersManagementComponent } from './presentations/pages/users-management/users-management.component';
import { DeletedItemsComponent } from './presentations/pages/deleted-items/deleted-items.component';

@NgModule({
  imports: [
    RouterModule.forRoot(
      [
        {
          path: '',
          component: AppLayoutComponent,
          children: [
            {
              path: '',
              redirectTo: '/user-activity',
              pathMatch: 'full',
            },
            {
              path: 'user-activity',
              component: UserActivityComponent,
            },
            {
              path: 'event-revenue',
              component: EventRevenueComponent,
            },
            {
              path: 'transactions',
              loadChildren: () =>
                import('./presentations/pages/transactions/transactions.routes').then((m) => m.TRANSACTIONS_ROUTES),
            },
            {
              path: 'payout-request',
              component: PayoutRequestComponent,
            },
            {
              path: 'organizer-balances',
              component: BalancesComponent,
            },
            {
              path: 'earnings-statement',
              loadComponent: () =>
                import(
                  './presentations/pages/earnings-statement/earnings-statement.component'
                ).then((m) => m.EarningsStatementComponent),
            },
            {
              path: 'audit-logs',
              loadChildren: () =>
                import('./presentations/pages/audit-logs/audit-logs.routes').then(
                  (m) => m.AUDIT_LOGS_ROUTES,
                ),
            },
            {
              path: 'organizer-balances/:id',
              loadComponent: () =>
                import('./presentations/pages/balances-detail/balances-detail.component').then(
                  (m) => m.BalancesDetailComponent,
                ),
              pathMatch: 'full',
            },
            {
              path: 'paid-events',
              loadChildren: () =>
                import('./presentations/pages/paid-events/paid-events.module').then((m) => m.PaidEventsModule),
            },
            {
              path: 'synthese',
              loadChildren: () =>
                import('./presentations/pages/synthesis/synthesis.module').then((m) => m.SynthesisModule),
            },
            {
              path: 'studio',
              loadComponent: () =>
                import('./presentations/pages/studio/studio.component').then((m) => m.StudioComponent),
            },
            {
              path: 'a-traiter',
              loadChildren: () => import('./presentations/pages/todo/todo.module').then((m) => m.TodoModule),
            },
            {
              path: 'segments',
              loadChildren: () =>
                import('./presentations/pages/segments/segments.module').then((m) => m.SegmentsModule),
            },
            {
              path: 'remplissage',
              loadChildren: () =>
                import('./presentations/pages/fill-rate/fill-rate.module').then((m) => m.FillRateModule),
            },
            {
              path: 'activites-en-difficulte',
              loadChildren: () =>
                import('./presentations/pages/needing-help/needing-help.module').then((m) => m.NeedingHelpModule),
            },
            {
              path: 'acquisition',
              loadChildren: () =>
                import('./presentations/pages/acquisition/acquisition.module').then((m) => m.AcquisitionModule),
            },
            {
              path: 'activation',
              loadChildren: () =>
                import('./presentations/pages/activation/activation.module').then((m) => m.ActivationModule),
            },
            {
              path: 'appariement',
              loadChildren: () =>
                import('./presentations/pages/matching/matching.module').then((m) => m.MatchingModule),
            },
            {
              path: 'carte-de-chaleur',
              loadChildren: () =>
                import('./presentations/pages/heatmap/heatmap.module').then((m) => m.HeatmapModule),
            },
            {
              path: 'stores',
              loadChildren: () =>
                import('./presentations/pages/stores/stores.module').then((m) => m.StoresPageModule),
            },
            {
              path: 'analyse-croisee',
              loadChildren: () =>
                import('./presentations/pages/cross-analysis/cross-analysis.module').then(
                  (m) => m.CrossAnalysisModule,
                ),
            },
            {
              path: 'villes-a-activer',
              loadChildren: () =>
                import('./presentations/pages/cities-to-activate/cities-to-activate.module').then(
                  (m) => m.CitiesToActivateModule,
                ),
            },
            {
              path: 'villes-en-doublon',
              loadChildren: () =>
                import('./presentations/pages/duplicate-cities/duplicate-cities.module').then(
                  (m) => m.DuplicateCitiesModule,
                ),
            },
            {
              path: 'legal',
              loadChildren: () => import('./presentations/pages/legal/legal.module').then((m) => m.LegalModule),
            },
            {
              path: 'commission',
              loadChildren: () =>
                import('./presentations/pages/commission/commission.module').then((m) => m.CommissionModule),
            },
            {
              path: 'cgv-acceptance',
              loadChildren: () =>
                import('./presentations/pages/cgv-acceptance/cgv-acceptance.module').then((m) => m.CGVAcceptanceModule),
            },

            {
              path: 'events',
              component: EventsComponent,
            },
            {
              path: 'past-events',
              component: PastEventsComponent,
            },
            {
              path: 'users',
              component: UsersComponent,
            },
            {
              path: 'users/:id',
              component: UserProfileComponent,
            },
            {
              path: 'report',
              component: ReportComponent,
            },
            {
              path: 'groups',
              component: GroupsManagementComponent
            },
            {
              path:'users-management',
              component: UsersManagementComponent,
            },
            {
              path: 'activities',
              component: ActivitiesManagementComponent
            },
            {
              path: 'deleted-items',
              component: DeletedItemsComponent
            }

          ],
          canActivate: [AdminGuard],
          canActivateChild: [AdminGuard],
        },
        { path: 'login', component: LoginComponent },
        { path: 'notfound', component: NotfoundComponent },
        { path: '**', redirectTo: '/notfound' },
      ],
      {
        scrollPositionRestoration: 'enabled',
        anchorScrolling: 'enabled',
        onSameUrlNavigation: 'reload',
      },
    ),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
